import {
  combineReducers
} from 'redux'
import {
  SHOPPING,
  POPULAR_SHOPPING,
  SHOPPING_DETAILS
} from '../../actions/actionTypes'
import {
  fetchingData,
  initStateLang
} from '../../utils'

const initailState = {
  loading: false,
  error: '',
  data: [],
  lastUpdate: ''
}

const list = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case SHOPPING.REQUEST:
    return {
      ...state,
      loading: true,
      error: '',
    }
  case SHOPPING.SUCCESS:
    return {
      ...state,
      loading: false,
      error: '',
      [action.lang]: { data: action.data, lastUpdate: action.lasted }
    }
  case SHOPPING.FAILURE:
    return {
      ...state,
      loading: false,
      error: action.error,
    }
  default:
    return state
  }
}
const popular = (state = initStateLang(initailState, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case POPULAR_SHOPPING.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case POPULAR_SHOPPING.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case POPULAR_SHOPPING.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
const initailStateDetail = {
  loading: false,
  error: '',
  data: {}
}
const details = (state = initStateLang(initailStateDetail, ['data', 'lastUpdate']), action) => {
  switch (action.type) {
    case SHOPPING_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        [action.lang]: { data: {} }
      }
    case SHOPPING_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        [action.lang]: { data: action.data, lastUpdate: action.lasted }
      }
    case SHOPPING_DETAILS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
export default combineReducers({
  list,
  popular,
  details
})


// WEBPACK FOOTER //
// ./src/containers/Shopping/reducer.js